var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1024_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75 10C2.75 10.9193 2.91597 11.8295 3.23844 12.6788C3.56091 13.5281 4.03356 14.2997 4.6294 14.9497C5.22524 15.5998 5.93261 16.1154 6.71111 16.4672C7.48962 16.8189 8.32402 17 9.16667 17C10.0093 17 10.8437 16.8189 11.6222 16.4672C12.4007 16.1154 13.1081 15.5998 13.7039 14.9497C14.2998 14.2997 14.7724 13.5281 15.0949 12.6788C15.4174 11.8295 15.5833 10.9193 15.5833 10C15.5833 9.08075 15.4174 8.1705 15.0949 7.32122C14.7724 6.47194 14.2998 5.70026 13.7039 5.05025C13.1081 4.40024 12.4007 3.88463 11.6222 3.53284C10.8437 3.18106 10.0093 3 9.16667 3C8.32402 3 7.48962 3.18106 6.71111 3.53284C5.93261 3.88463 5.22524 4.40024 4.6294 5.05025C4.03356 5.70026 3.56091 6.47194 3.23844 7.32122C2.91597 8.1705 2.75 9.08075 2.75 10Z",
    stroke: "#1E5A5B",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 21L13.75 15",
    stroke: "#1E5A5B",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1024_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/iconSearch.8d9f8bc1462399e705f1b44ff1a2631b.svg";
export { ForwardRef as ReactComponent };